import { render, staticRenderFns } from "./Want.vue?vue&type=template&id=71dd4624&scoped=true&"
import script from "./Want.vue?vue&type=script&lang=js&"
export * from "./Want.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71dd4624",
  null
  
)

export default component.exports